import clsx from "clsx";
import React, { useRef } from "react";
import classes from "./StatusIndicator.module.css";
import { CheveronDown } from "../../constant";
import { ViewDetailIcon } from "../../constant";
import { TieredMenu } from "primereact/tieredmenu";
import moment from "moment";

const StatusIndicator = ({
  indicator = "Active",
  bookingStatus,
  menuItems,
  bookingDate,
  bookingEndTime,
  action = true,
}) => {
  const menu = useRef(null);

  // Check if the booking has passed
  const isBookingPassed = () => {
    if (!bookingDate || !bookingEndTime) return false;

    // Create a datetime by combining the date and end time
    const bookingEndDateTime = moment(
      `${bookingDate} ${bookingEndTime}`,
      "YYYY-MM-DD HH:mm:ss"
    );
    const now = moment();

    // Return true if booking end time is before current time
    return bookingEndDateTime.isBefore(now);
  };

  const derivedStatus = () => {
    // If status is pending (3) but the booking date has passed, show as cancelled
    // if (bookingStatus === 3 && isBookingPassed()) {

    //  return "cancelled";}
    if (bookingStatus == 1) {
      return "confirmed";
    } else if (bookingStatus == 3) {
      return "pending";
    } else {
      return "cancelled";
    }
  };

  // Determine the visual status for styling
  const visualStatus = () => {
    // For pending bookings that have passed
    // if (bookingStatus === 3 && isBookingPassed()) {
    //   return 2; // Use cancelled styling
    // }
    return bookingStatus;
  };

  const items = [
    {
      label: "View Details",
      icon: <ViewDetailIcon />,
    },
  ];

  return (
    <span className={classes.wrapper}>
      <span
        className={clsx(classes.ball, {
          [classes.confirm]: visualStatus() === 1,
          [classes.pending]: visualStatus() === 3,
          [classes.cancelled]: visualStatus() === 2,
        })}
      />
      <span className={classes.title}>
        {derivedStatus()}
        {/* Only show dropdown for genuine pending bookings that haven't passed */}
        {action && bookingStatus === 3 && !isBookingPassed() && (
          <span
            className={classes.status}
            onClick={(e) => menu.current.toggle(e)}
          >
            <CheveronDown className={classes.icon} />
          </span>
        )}
        <TieredMenu popup ref={menu} model={menuItems} breakpoint="767px" />
      </span>
    </span>
  );
};

export default StatusIndicator;
